import { getDate, toISOString, useApiService } from "medere-ui-framework";
import { HealthPatientCoverageDTO } from "../../dto/HealthPatientCoverageDTO";
import { PatientRecordDTO } from "../../interface/interface";

export function useHealthPatientService() {
  const { api, getMethod } = useApiService();
  const baseEndpoint = "/api/secured/healthpatientservice";

  function saveHealthPatientCoverage(coverage: HealthPatientCoverageDTO) {
    return api.post(`${baseEndpoint}/saveHealthPatientCoverage`, {
        ...coverage,
        coveragestart: toISOString(getDate(coverage.coveragestart)),
        coverageend: toISOString(getDate(coverage.coverageend))
      }).then(res => res);
  }

  function getPatientByHealthPatientServiceId(healthPatientServiceId: number): Promise<PatientRecordDTO> {
    return getMethod<PatientRecordDTO>({
      basePath: baseEndpoint,
      endpoint: "/getPatientByHealthPatientServiceId",
      params: { healthPatientServiceId }
    }).catch((error) => {
      console.error(error);
      throw error;
    });
  }

  function isHospitalizationService(healthPatientServiceId: number): Promise<boolean> {
    return getMethod<boolean>({
      basePath: baseEndpoint,
      endpoint: "/isHospitalizationService",
      params: { healthPatientServiceId }
    }).catch(error => {
      console.error(error);
      throw error;
    });
  }

  return {
    saveHealthPatientCoverage,
    getPatientByHealthPatientServiceId,
    isHospitalizationService
  };
}
